import React, { Component } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
// import ReactDOM from 'react-dom'; 
import ReactDOM from 'react-dom';
import lan from './languages';

import Bets from './components/Bets';
import Printer from './components/Printer';
import Sidepanel from './components/Sidepanel';
import Event from './components/Event';
import Widget from './components/Widget';
import Centerpanel from './components/Centerpanel';
// import Footer from './components/Footer';
import Navbar from './components/Navbar';
// import ccs from 'css';
// import firts from './first.png';


import swal from 'sweetalert';

import {LOGO,FORMAT,OPEN,LAN } from './settings';

import moment from 'moment';
import momentES from 'moment/locale/es';


var api = 'https://betbets.club/admin/api'
// var api = 'https://griffon.bet/gecko/api'
// var api = 'http://localhost/gecko/api'


class App extends Component {
  constructor() {
    super()
    this.state = {

      items: {},

      multiple: true,     
      format: FORMAT,    
      language: LAN,
      open: OPEN,
      lastItem: {
        info: {},
        temporal: {},
      },
      user: {
        login: false,
      },
      data: {},
      price: 1,
    };
    this.format = this.format.bind(this);
    this.language = this.language.bind(this);
    this.login = this.login.bind(this);

    this.changeFormat = this.changeFormat.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.saveStakes = this.saveStakes.bind(this);
    this.changeStake = this.changeStake.bind(this);
    this.changeSingleWin = this.changeSingleWin.bind(this);
    this.checkItems = this.checkItems.bind(this);
    this.addToPrinter = this.addToPrinter.bind(this);
    this.translateCupon = this.translateCupon.bind(this);
  }

  handleNewUserMessage = (newMessage) => {
    console.log(`New message incomig! ${newMessage}`);
    // Now send the message throught the backend API
  }

  handleOpenModal() {
    this.setState({ open: true });
  }
  changeLanguage() {

    if (this.state.language === "en") {
      this.setState({ language: 'es' })
      moment.updateLocale('es', momentES);
      localStorage.setItem('language', 'es');
    } else {
      moment.updateLocale('en', momentES);
      this.setState({ language: 'en' })
      localStorage.setItem('language', 'en');
    }
  }
  changeFormat = (event) => {
    if (this.state.format === "AMERICAN") {
      this.setState({ format: "DECIMAL" }, () => {
        this.translateCupon();
      });
      localStorage.setItem('format', "DECIMAL");
    } else {
      this.setState({ format: "AMERICAN" }, () => {
        this.translateCupon();
      });
      localStorage.setItem('format', "AMERICAN");
    }
  }

  changeStake(id, stake) {
    // console.log(event);
    // console.log(id);
    this.checkItems();
    let items = this.state.items;


    if (items[id]) {
      items[id].stake = stake.replace(/\d(?=(\d{3})+\.)/g, '$&,');
      items[id].win = ((stake * items[id].price) - items[id].stake).toFixed(2);
      this.setState({ items });
      // localStorage.setItem('tickets', JSON.stringify(items));
    }
  }
  changeSingleWin(id, win) {
    this.checkItems();
    // console.log(event);
    // console.log(id);
    let items = this.state.items;
    if (items[id]) {
      items[id].stake = (win / (items[id].price - 1)).toFixed(2);
      items[id].win = win;

      this.setState({ items });
      localStorage.setItem('tickets', JSON.stringify(items));
    }

  }
  saveStakes() {
    console.log("saved it");
    localStorage.setItem('tickets', JSON.stringify(this.state.items));
  }
  format(value) {
    let into = parseFloat(value);
    let outo = 0;

    if (this.state.format === "AMERICAN") {
      if (into >= 2) {
        outo = parseInt((into - 1) * 100, 10);
      } else if (into < 2) {
        outo = parseInt((-100) / (into - 1), 10);
      }
      if (outo > 0) outo = '+' + outo;
    } else
      if (this.state.format === "DECIMAL") {
        outo = value;
      }
    return outo;
  }
  language(text) {
    let label = {}
    if (this.state.language === "es") {
      label = lan.es
    } else {
      label = lan.en
    }
    if (text != null) {
      if (this.state.language === "es") {
        label = lan.es[text];
      } else if (this.state.language === "en") {
        label = lan.en[text];
      }
      if (label === undefined) {
        label = {
          'text': text
        }
      }
      else {

        label = {
          'text': label
        }
      }
      // console.log(label);

    }

    return label;
  }
  checkItems() {
    // console.log('Checking..');

    let items = this.state.items;

    let seen = {};
    Object.keys(items).map(i => {
      if (seen[items[i].idmatch]) {
        this.setState({ multiple: false })
        return
      } else {
        seen[items[i].idmatch] = true;
      }
      this.setState({ multiple: true })
    })
    // console.log(seen);

  }
  removeFromCupon = (id) => {
    if (id) {
      let temporal = this.state.items;
      let p = 1;
      delete temporal[id];
      Object.keys(temporal).map(idApuesta => {
        p = p * temporal[idApuesta].price;
        return null;
      })
      this.setState({
        items: temporal,
        price: p.toFixed(2)
      })
      localStorage.setItem('tickets', JSON.stringify(temporal));
    } else {
      this.setState({
        items: {},
        price: 1,
        multiple: false
      })
      localStorage.setItem('tickets', JSON.stringify({}));
    }

    this.checkItems();
  };
  saveCupon = (stake, type = null) => {
    let temporal = this.state.items;
    let products = Object.keys(temporal);

    // if (type === 'm') {
    let totalStake = parseFloat(products.reduce(function (sum, key) {
      return sum + parseFloat(temporal[key]['stake']);
    }, 0));

    let totalReturn = parseFloat(products.reduce(function (sum, key) {
      return sum + (parseFloat(temporal[key]['stake']) * parseFloat(temporal[key]['price'])) - parseFloat(temporal[key]['stake']);
    }, 0));

    if (((stake === "" || stake === " " || stake <= 0) && type === 'm') || (isNaN(totalStake) && type === 'i')) {
      swal({
        title: this.language().error,
        text: this.language().selectstake,
        icon: "error",
      })
    } else if (this.state.user.login === false) {
      swal({
        title: this.language().error,
        text: this.language().login,
        icon: "error",
      })
    } else {



      if (products.length > 0) {

        let wrapper = document.createElement('div');
        let amounts = 0;
        const Confirm = () => {
          // let p = 1;
          let obj = products.map((idApuesta) => {

            return (
              <div key={idApuesta} style={{ lineHeight: '16px', borderBottom: '1px solid grey', padding: 5 }}>

                {/* RightColumn */}
                <div className="leyend">
                  <span>{this.language(temporal[idApuesta].option).text + " | " + this.format(temporal[idApuesta].price)}</span>
                  <br />
                  <span>{type === 'i' ? "$" + temporal[idApuesta].stake : ""}</span>
                </div>

                {/* LeftColumn */}
                <div style={{ position: "relative", textAlign: "left" }}>
                  <span style={{ display: "block", fontSize: 15, color: "rgb(255, 255, 255)" }}>
                    {temporal[idApuesta].liga}
                  </span>
                  <span style={{ display: "block", fontSize: 14, color: "#0cd664" }}>
                    {temporal[idApuesta].name}
                  </span>
                  <div style={{ display: "inline", paddingTop: 10, fontSize: 12 }}>
                    {moment(temporal[idApuesta].time * 1000).format('MMM DD, YYYY - H:mm')}
                  </div>
                  <span style={{ display: "block", fontSize: 14, color: "#0cd664" }}>
                    {this.language(temporal[idApuesta].logro).text}
                  </span>
                </div>
                {/* // */}
              </div>
            )
          });

          amounts = type === 'm' ? stake : totalStake.toString();
          return (
            <div style={{ height: 'calc(100% - 10px)' }}>
              <div className="scrollview" style={{ overflowY: 'scroll', paddingRight: 5 }}>
                {obj}
              </div>


              <div style={{ textAlign: 'right' }}>
                {this.language().stake}: <span style={{ fontSize: 20, color: "#0cd664" }}>{"$" + parseFloat(amounts).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
              </div>

              <div style={{ textAlign: 'right' }}>
                {this.language().win}: <span style={{ fontSize: 20, color: "#0cd664" }}>{"$" + parseFloat(type === 'm' ? amounts * (this.state.price - 1) : totalReturn).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
              </div>
            </div>
          )

        }
        ReactDOM.render(<Confirm />, wrapper);
        let el = wrapper.firstChild;

        swal({
          title: this.language().ok,
          content: el,
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "",
              closeModal: true,
            },
            confirm: {
              text: this.language().send,
              value: true,
              visible: true,
              className: "",
              closeModal: false
            }
          },
          closeOnEsc: false,
          closeOnClickOutside: false,
        }).then(name => {
          // console.log(name);
          if (!name) throw null;
          let prettyUser = {
            "N_id": this.state.user.userdata.N_id,
            "A_id": this.state.user.userdata.A_id,
            "D_id": this.state.user.userdata.D_id,
          }
          let x = JSON.stringify({ user: prettyUser, type: type, items: this.state.items, stake: amounts, price: this.state.price, counter: Object.keys(this.state.items).length });
          // console.log(x);
          // return prettyUser;
          return fetch(api + '/saveCupon/m', {
            method: 'post',
            body: x
          }).then(res => { return res });


        }).then(results => {
          return results.json();
        }).then(res => {
          console.log(res);
          if (res.status === 200) {
            let user = this.state.user;
            user['userdata']['balance'] = user['userdata']['balance'] - amounts;

            let tikes = user['userdata']['Tickets'];
            tikes[res.info.ID] = { Estado: "Espera", Fecha: res.info.Fecha, Ganancia: res.info.Ganancia, Id: res.info.ID, Monto: res.info.Monto, nEventos: res.info.nEventos };
            user['userdata']['Tickets'] = tikes;
            this.setState({
              user
            })
            localStorage.setItem('user', JSON.stringify(user));
            console.log(res)
            this.setState({
              lastItem: {
                info: res.info,
                temporal: res.items
              }
            });

            if (user.userdata.auto) {
              swal(this.language().successmsj);
              this.removeFromCupon();
            } else {


              swal({
                title: this.language().success,
                text: this.language().successmsj,
                icon: "success"
              }).then(next => {
                this.removeFromCupon();
                // Impresion
                swal({
                  title: this.language().print + "?",
                  icon: "info",
                  text: this.language().printmsj,
                  buttons: {
                    cancel: {
                      text: "NO",
                      value: null,
                      visible: true,
                      closeModal: true,
                    },
                    confirm: { text: this.language().yes, value: true },
                  }

                }).then(resp => {
                  if (resp) {



                    // var textEncoded = encodeURI(JSON.stringify(res));
                    // let value = "intent://" + textEncoded + "#Intent;scheme=quickprinter;package=pe.diegoveloper.printerserverapp;end;";
                    // window.location.href = value;

                    // console.log(value);
                    
                    this.setState({ open: true })
                    window.print();

                  }

                  this.removeFromCupon();
                })

              })
            }

          } else {
            swal({
              title: this.language().warning,
              text: res.status,
              icon: "warning",
            })
            // console.log(res);
          }
        }).catch(err => {
          if (err) {
            swal("Oh noes!", err, "error");
          } else {
            swal.stopLoading();
            swal.close();
          }
        });


      } else {
        swal({
          title: this.language().error,
          text: this.language().select,
          icon: "error",
        })
      }

    }



  }
  translateCupon() {
    let items = this.state.items;
    let aux = {}

    Object.keys(items).map((i) => {
      aux[i] = { ...items[i], odd: this.format(items[i].price) };
    })
    this.setState({ items: aux })
  }
  addTocart = (data) => {

    let temporal = this.state.items;
    // let multiple = true;
    let myId = data.idmatch + '89' + data.type + '79' + data.choose;

    let p = 1;
    if (temporal[myId]) {
      if (temporal[myId].type == data.type && temporal[myId].choose == data.choose) {
        this.removeFromCupon(myId);
      }

    } else {
      temporal[myId] = { ...data, stake: '' };
      Object.keys(temporal).map(idApuesta => {
        p = p * temporal[idApuesta].price;
        return null;
      })

      this.setState({
        items: temporal,
        // multiple,
        price: p.toFixed(2)
      })

      localStorage.setItem('tickets', JSON.stringify(temporal));
      localStorage.setItem('date', new Date().getTime() + 600000);

    }

    this.checkItems();


  }
  removeFromUser = () => {
    this.setState({
      user: { login: false }
    })
    localStorage.removeItem('user');

  };
  login = (raw, ui, auto) => {


    let value = raw;
    if (raw.user)
      localStorage.setItem('value', JSON.stringify(raw)); //para reiniciar la sesion


    document.getElementById('loginbtn').innerHTML = this.language().loading;
    document.getElementById('lds').className = 'lds-facebook d-xs-block';
    let loginBtn = document.getElementById('refresh');
    loginBtn ? loginBtn.classList.add("progress-bar-striped", "progress-bar-animated") : "";
    let loginUrl = '/login/m';
    if (auto) {
      // console.log(raw, auto);
      loginUrl = '/autologin/m';
      // this.setState({auto:true})
    }




    const postData = (url = '', data = {}) => {
      // Default options are marked with *
      return fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json; charset=utf-8'
        },
        body: data, // body data type must match "Content-Type" header
      })
        .then(response => response.json()) // parses response to JSON
        .catch(error => console.error(`Fetch Error =\n`, error));
    };

    const searchParams = Object.keys(value).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(value[key]);
    }).join('&');
    // console.log(searchParams);

    postData(api + loginUrl, searchParams)
      .then(flow => {
        // console.log(flow);

        let data = flow.info;
        if (data) {
          if (data.CODE) {
            // console.log("Found", ui);

            this.addToUser({ userdata: data, login: true });
            auto && this.addToUser({ userdata: { ...data, auto: true }, login: true });
            this.setState({ login: true });
            if (ui && !auto) {
              swal({
                title: this.language().login,
                text: this.language().welcome + ", " + data.fullname,
                icon: "success"
              });
            }
            localStorage.setItem('session', new Date().getTime() + 7200000); //2 hrs
            document.getElementById("closeModalLogin").click();

          } else {
            console.log("Not Found 1");
            this.removeFromUser();
            swal(this.language().login, this.language().nologin, 'error');

          }
        } else {
          console.log("Not Found 2");
          this.removeFromUser();
          swal(this.language().login, this.language().nologin, 'error');

        }


        document.getElementById('loginbtn').innerHTML = this.language().login;
        document.getElementById('lds').className = 'lds-facebook d-none';
        loginBtn ? loginBtn.classList.remove("progress-bar-striped", "progress-bar-animated") : "";
      }) // JSON from `response.json()` call
      .catch(error => { console.error(error); swal("Error", "No network connection", 'error'); });



  }
  addToUser = (data) => {

    this.setState({
      user: data
    })

    localStorage.setItem('user', JSON.stringify(data));

  }
  addToPrinter = (data) => {
    this.setState({ lastItem: data })
  }
  componentDidMount() {
    // console.log(this.props.matchs)

    window.addEventListener("newContentAvailable", () => {
      swal("New Content Available", "Please Refresh your browser");

    });

    this.checkItems();
    var date = new Date();
    if (localStorage.getItem('tickets') != null && localStorage.getItem('date') != null) {
      // console.log("App mounting....");

      var timestamp = date.getTime();
      if (localStorage.getItem('date') > timestamp) {
        let temporal = JSON.parse(localStorage.getItem('tickets'));
        let p = 1;
        Object.keys(temporal).map(idApuesta => {
          p = p * temporal[idApuesta].price;
          return null;
        })
        this.setState({ items: temporal, price: p.toFixed(2) });
      }
    }


    if (localStorage.getItem('user') != null && localStorage.getItem('session') != null) {
      // console.log("App mounting....");

      var session = date.getTime();
      if (localStorage.getItem('session') > session) {
        let usertem = JSON.parse(localStorage.getItem('user'));
        // console.log(temporal);
        // !usertem.userdata.auto && 
        if (usertem.userdata.auto) {
          document.title = "External Core";
        }
        this.setState({ user: usertem });
      } else {
        this.setState({ user: { login: false } })
      }
    }

    if (localStorage.getItem('format') != null) {
      let format = localStorage.getItem('format');
      // console.log(temporal);
      this.setState({ format }, () => {
        this.translateCupon();
      });
    }
    // else {
    // this.setState({ format: "DECIMAL" });
    // }

    if (localStorage.getItem('language') != null) {
      let language = localStorage.getItem('language');
      // console.log(temporal);
      this.setState({ language });
      moment.updateLocale(language, momentES);
    }
    // else {
    //   this.setState({ language: "en" });
    //   moment.updateLocale('en', momentES);
    // }
    // this.translateCupon();
  }


  render() {
    return (
      <Router basename={'/sports'}>
        <div className="layout">

          <div className="wrapper ">
            <Route render={(props) =>
              <Sidepanel {...props} logo={LOGO} api={api} language={this.language} changeLanguage={this.changeLanguage} changeFormat={this.changeFormat}
                format={this.state.format} auto={this.state.user.userdata ? (this.state.user.userdata.auto ? true : false) : false}
              />}
            />

            <div id="content">
              <Navbar logo={LOGO} api={api} user={this.state.user} login={this.login} language={this.language}
                changeLanguage={this.changeLanguage} removeFromUser={this.removeFromUser}
                addToUser={this.addToUser} format={this.state.format} changeFormat={this.changeFormat} />
              <Switch>
                <Route exact path="/" render={(props) =>
                  <Centerpanel {...props} loading={true} items={this.state.items} api={api} language={this.language} addTocart={this.addTocart} format={this.format} />}
                />
                <Route exact path="/logout" render={(props) => {
                  this.removeFromUser();
                  return <Redirect to='/' />;
                  // return <Centerpanel {...props} loading={true} items={this.state.items} api={api} language={this.language} addTocart={this.addTocart} format={this.format} />
                }
                }
                />
                <Route exact path={`/auto/:token`} render={(props) =>
                  <Centerpanel {...props} login={this.login} loading={true} items={this.state.items} api={api} language={this.language} addTocart={this.addTocart} format={this.format} />}
                />
                <Route exact path="/league/:idleague" render={(props) =>
                  <Centerpanel {...props} loading={true} items={this.state.items} api={api} language={this.language} addTocart={this.addTocart} format={this.format} />} />
                <Route exact path="/group/:idgroup" render={(props) =>
                  <Centerpanel {...props} loading={true} items={this.state.items} api={api} language={this.language} addTocart={this.addTocart} format={this.format} />} />
                <Route exact path={`/event/:idevent`} render={(props) =>
                  <Event {...props} items={this.state.items} api={api} language={this.language} addTocart={this.addTocart} format={this.format} />} />
                <Route exact path="/mybets" render={(props) =>
                  <Bets {...props} user={this.state.user} api={api} language={this.language} format={this.format} addToPrinter={this.addToPrinter} reload={this.login} />} />

                <Redirect to="/" />
              </Switch>
              <Widget open={this.state.open} multiple={this.state.multiple} saveStakes={this.saveStakes}
                changeSingleWin={this.changeSingleWin}
                stake={this.state.stake} quake={this.state.stake * this.state.price}
                price={this.state.price} language={this.language} changeStake={this.changeStake} checkItems={this.checkItems}
                items={this.state.items} removeFromCupon={this.removeFromCupon} save={this.saveCupon}
                item={this.state.lastItem ? this.state.lastItem : { data: "", info: "" }} />

            </div>
          </div>

          <Printer logo={LOGO} language={this.language} lastItem={this.state.lastItem} format={this.format} />
          {/* <Footer /> */}

        </div >
      </Router>
    )
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js